/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UninstallAction/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function UninstallAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/UninstallAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let metaEnvironmentValueData = fromData.useDataValue({ viewPath,
context: 'meta',
path: 'environment',
})
let constantData = 'production'
let aggregateData = fromAggregate.not(metaEnvironmentValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}